// @ts-nocheck
import React from 'react';
import { ArrowLeft, ArrowRight, Calendar, FileSpreadsheet } from 'lucide-react';
import './TBConverter.css';

const TBConverterPeriodReview = ({
  analysisData,
  onContinue,
  onBack,
  loading,
  hasExistingResults = false,
  onViewResults
}) => {
  const { analysisResult, files, sheetSelections, selectedConfig } = analysisData;

  const handleContinue = () => {
    onContinue({
      analysisResult,
      files,
      sheetSelections,
      selectedConfig
    });
  };

  const getFileName = (fileIndex) => {
    if (files && files[fileIndex]) {
      return files[fileIndex].name;
    }
    return `File ${fileIndex + 1}`;
  };

  const sheets = analysisResult?.sheets || [];
  const totalAccounts = sheets.reduce((sum, s) => sum + (s.account_count || 0), 0);
  const uniqueFiles = new Set(sheets.map(s => s.file_index)).size;

  return (
    <div className="period-review-container">
      <div className="period-review-header">
        <div className="header-icon tb-icon">
          <Calendar size={24} />
        </div>
        <div>
          <h3>Review Detected Periods</h3>
          <p className="period-review-description">
            Review detected periods below. Account classification will be performed automatically.
          </p>
        </div>
      </div>

      {/* Vertical timeline */}
      <div className="period-timeline">
        <div className="timeline-line" />

        {sheets.map((sheet, idx) => (
          <div key={idx} className="timeline-entry">
            <div className="timeline-node">{idx + 1}</div>
            <div className="timeline-content">
              <div className="timeline-content-primary">
                <span className="timeline-period-label">{sheet.detected_period || `Period ${idx + 1}`}</span>
                <span className="timeline-account-count">{sheet.account_count || 0} accts</span>
              </div>
              <div className="timeline-content-secondary">
                <FileSpreadsheet size={12} />
                <span className="timeline-filename" title={getFileName(sheet.file_index)}>
                  {getFileName(sheet.file_index)}
                </span>
                <span className="timeline-divider">/</span>
                <span className="timeline-sheet">{sheet.sheet_name}</span>
              </div>
            </div>
          </div>
        ))}

        <div className="timeline-summary">
          <div className="timeline-node timeline-node-summary" />
          <div className="timeline-summary-content">
            {sheets.length} period{sheets.length !== 1 ? 's' : ''} &middot; {totalAccounts} total accounts &middot; {uniqueFiles} source file{uniqueFiles !== 1 ? 's' : ''}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="period-review-actions">
        <button
          className="back-button"
          onClick={onBack}
          disabled={loading}
        >
          <ArrowLeft size={14} />
          Back
        </button>

        <div className="period-review-actions-right">
          {hasExistingResults && onViewResults && (
            <button
              className="view-results-button"
              onClick={onViewResults}
              disabled={loading}
            >
              View Results
              <ArrowRight size={14} />
            </button>
          )}
          <button
            className="analyze-button btn-animated"
            onClick={handleContinue}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="button-spinner"></div>
                Processing...
              </>
            ) : (
              <>
                Continue to Classification
                <ArrowRight size={14} />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TBConverterPeriodReview;
